module.exports = __webpack_public_path__ + "assets/images/extra-02.17fb39ca14914428d486e1cfb2e8f512.svg";